import { z } from "zod";

/**
 * Schema for validating Lottie animation JSON structure.
 * Requires frame rate (fr), layers array, width (w), and height (h).
 * Uses passthrough() to preserve additional Lottie animation properties.
 * @type {z.ZodObject}
 */
export const LottieJsonSchema = z
  .object({
    fr: z.number(),
    layers: z.array(z.unknown()),
    w: z.number(),
    h: z.number(),
  })
  .passthrough();
